/**
 * 文件上传组件
 * 基于aliyun-oss-sdk封装
 */
import EventEmitter from 'wolfy87-eventemitter'
import OSS from 'ali-oss'
import COS from 'cos-js-sdk-v5'
// @ts-ignore
import OBS from 'esdk-obs-browserjs'

import getToken from '@/services/get-token'
import store from '@/store/index'
import Axios from 'axios'
import utils from '@/utils/utils'

// 上传服务获取图片
interface UploaderObject {
  file: any
}

class Uploader {
  //传入参数
  info: UploaderObject = {
    file: null,
  }

  emit: any

  /**
   * 实例化
   */
  constructor({ file = null }: UploaderObject) {
    const info: UploaderObject = {
      file,
    }

    this.info = info
    this.startUpload(this.info.file)
  }

  /**
   * @name: 获取阿里云token
   * @param {type}
   * @return: TokenAPI.TOKENResponse | null
   */
  // eslint-disable-next-line max-statements
  async getToken(file: any): Promise<TokenAPI.TOKEN | null> {
    const { uuid, ticket } = store.state.userInfoInapp
    if (!uuid || !ticket) {
      this.emit('error', new Error('未登录'))
      return null
    }
    try {
      this.emit('get-token-start')
      // const file = files[0]
      const name = file.name.split('.')
      const suffix = name[name.length - 1] || 'jpg'
      let res = null
      let fileSize = file.size
      // console.log(1212, fileSize)
      let fileBase64Front64Data: any = await utils.getFileBase64(file)

      let fileBase64Front64 = fileBase64Front64Data.data
      let fileMd5 = await utils.getFileMd5(file, 2097152)

      let data = {
        base64: fileBase64Front64,
        fileSize: fileSize,
        fileMd5: fileMd5,
        fileSubfix: suffix,
      }

      const response: API.APIRespose = await getToken(data)

      if (!response || !response.data) {
        //TODO 异常提示
        this.emit('error', new Error(response.msg || '上传获取token失败'))
        return null
      }
      const resultData = response.data
      // const {
      //   stsToken: { accessKeyId, accessKeySecret, securityToken },
      //   bucketInfo: { endpoint, bucket },
      // } = resultData

      this.emit('get-token-success')
      // const resuleToken: TokenAPI.TOKENResponse = {
      //   keys: resultData.bucketInfo.keys,
      //   conf: {
      //     accessKeyId,
      //     accessKeySecret,
      //     stsToken: securityToken,
      //     endpoint,
      //     bucket,
      //   },
      // }
      return resultData
    } catch (err) {
      this.emit('error', err)
      return null
    }
  }

  /**
   * 开始上传文件
   * @param {Array} files
   */
  // eslint-disable-next-line max-statements
  async startUpload(files: any[]) {
    // 如果没有
    if (!files) {
      return
    }
    // debugger
    this.emit('start-upload')

    // const { uuid, ticket } = store.state.userInfoInapp
    // const param = new FormData() // 创建form对象
    // param.append('file', files[0]) // 通过append向form对象添加数据
    // param.append('uuid', uuid || '')
    // param.append('ticket', ticket || '')

    // Axios.post('//upload-ugc.bz.mgtv.com/upload/v2/image', param, {
    //   headers: { 'Content-Type': 'multipart/form-data' },
    // })
    // .then((res: any) => {
    //   if (res.data.code === 200) {
    //     const fileInfo = {
    //       url: res.data.data.url,
    //       key: res.data.data.key,
    //     }
    //     this.emit('success', fileInfo)
    //   } else {
    //     this.emit('error', res.data.msg)
    //   }
    // })
    // .catch((err: any) => {
    //   this.emit('error', err)
    // })
    // console.log(1212, files)
    const file = files[0]
    const info: TokenAPI.TOKEN | null = await this.getToken(files[0])
    console.log(1212, info)
    if (info) {
      const stsData = info
      const aliyunConfig = {
        region: stsData.bucketInfo.region,
        accessKeyId: stsData.stsToken.accessKeyId,
        accessKeySecret: stsData.stsToken.accessKeySecret,
        stsToken: stsData.stsToken.securityToken,
        endpoint: stsData.bucketInfo.endpoint,
        bucket: stsData.bucketInfo.bucket,
        timeout: '300s',
      }
      const txConfig = {
        SecretId: stsData.stsToken.accessKeyId, // sts服务下发的临时 secretId
        SecretKey: stsData.stsToken.accessKeySecret, // sts服务下发的临时 secretKey
        SecurityToken: stsData.stsToken.securityToken, // sts服务下发的临时 SessionToken
        ExpiredTime: new Date(stsData.stsToken.expiration).getTime() / 1000, // 临时密钥过期时间
      }
      const hwConfig = {
        access_key_id: stsData.stsToken.accessKeyId,
        secret_access_key: stsData.stsToken.accessKeySecret,
        security_token: stsData.stsToken.securityToken,
        server: stsData.bucketInfo.endpoint,
        timeout: 300,
      }
      let result: any = null
      if (stsData.bucketInfo.cloudId === 21) {
        const ossClient = new OSS(aliyunConfig)
        result = await ossClient.put(stsData.keyInfo.key, file, {
          headers: {
            'x-oss-meta-fileinfo': `${stsData.keyInfo.fileinfo}`,
            'Cache-Control': 'max-age=31536000',
          },
        })
      }
      if (stsData.bucketInfo.cloudId === 22) {
        const cosClient = new COS(txConfig)
        result = await cosClient.uploadFile({
          Bucket: stsData.bucketInfo.bucket, // 填入您自己的存储桶，必须字段
          Region: stsData.bucketInfo.region, // 存储桶所在地域，例如 ap-beijing，必须字段
          Key: stsData.keyInfo.key, // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
          Body: file,
          Headers: {
            'x-cos-meta-fileinfo': `${stsData.keyInfo.fileinfo}`,
            'Cache-Control': 'max-age=31536000',
          },
        })
        result.url = `https://${result.Location}`
      }
      if (stsData.bucketInfo.cloudId === 23) {
        const obsClient = new OBS(hwConfig)
        result = await obsClient.putObject({
          Bucket: stsData.bucketInfo.bucket,
          Key: stsData.keyInfo.key,
          Body: file,
          headers: {
            'x-obs-meta-fileinfo': `${stsData.keyInfo.fileinfo}`,
            'Cache-Control': 'max-age=31536000',
          },
        })
        result.url = `https://${stsData.bucketInfo.bucket}.${stsData.bucketInfo.endpoint}/${stsData.keyInfo.key}`
      }
      result.file = file
      result.key = stsData.keyInfo.key
      console.log(1212, result)
      this.emit('success', result)

      // const client = new OSS(info.conf)

      // const key = info.keys

      // const imageRequestUrl = 'https://ugc.hitv.com/'

      // for (let i = 0; i < files.length; i++) {
      //   const file = files[i]
      //   const imageStr = file.type.split('/')[1]
      //   const imageName = key[i] + '.png'
      //   this.emit('upload')
      //   client
      //     .multipartUpload(imageName, file, {
      //       progress: (percentage: any, cpt: any) => {
      //         this.emit('process', ~~(percentage * 100))
      //       },
      //     })
      //     .then((result: OSS.MultipartUploadResult) => {
      //       console.log(result)
      //       const fileInfo = {
      //         url: imageRequestUrl + imageName + '?',
      //       }
      //       this.emit('success', fileInfo)
      //     })
      //     .catch((err: any) => {
      //       this.emit('error', err)
      //     })
      // }
    }

    // this.getToken(files.length).then((info: TokenAPI.TOKENResponse | null) => {
    //   if (info) {
    //     const client = new OSS(info.conf)

    //     const key = info.keys

    //     const imageRequestUrl = 'https://ugc.hitv.com/'

    //     for (let i = 0; i < files.length; i++) {
    //       const file = files[i]
    //       const imageStr = file.type.split('/')[1]
    //       const imageName = key[i] + '.' + imageStr
    //       this.emit('upload')
    //       client
    //         .multipartUpload(imageName, file, {
    //           progress: (percentage: any, cpt: any) => {
    //             this.emit('process', ~~(percentage * 100))
    //           },
    //         })
    //         .then((result: OSS.MultipartUploadResult) => {
    //           console.log(result)
    //           const fileInfo = {
    //             url: imageRequestUrl + imageName,
    //           }
    //           this.emit('success', fileInfo)
    //         })
    //         .catch((err: any) => {
    //           this.emit('error', err)
    //         })
    //     }
    //   }
    // })
  }
}

Object.assign(Uploader.prototype, EventEmitter.prototype)

export default Uploader
